import { useTranslation } from 'react-i18next'

const GangEnd = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="gang-end-title"
      fill="none"
      {...props}
    >
      <title id="gang-end-title">{t('antagonists:gang:components:end')}</title>
      <path
        d="M1663.15 606.68s5.46 76.11 6.35 91.47c.89 15.36-12.24 44.72-28.72 44.83-16.47.11-13.66-53.6-15.81-64.26-2.15-10.67-5.77-67.26-5.77-67.26l43.96-4.79Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1647.15 675.63c15.94-1.46 21.5 15.01 22.63 26.92 1.14 11.93.17 55.29-1.76 70.33-1.93 15.02-1.68 36.35-1.68 36.35l-30.55-6.01s1.73-7.01-.99-26.47c-2.72-19.44-9.12-73.09-9.86-81.82s8.84-18.06 22.2-19.3Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1637.9 796.74s-.11 10.36-2.89 21.92c-3.15 13.15-9.03 27.86-9.35 31.03-.61 5.94 1.01 19.61 1.04 25.3s.46 16.32.46 16.32 7.15-.55 8.81-6.31c1.66-5.76-1.35-20.15 2.73-20.4 5.07-.32 7.03 13.69 6.21 19.64-.82 5.96-13.52 12.81-15.25 16.67-1.75 3.87 2.83 12.4 2.83 12.4s20.81-12.5 25.74-15.56c4.94-3.06 11.57-26.64 13.5-30.75 1.31-2.79-5.7-33.17-5.48-43.75.23-10.57-.3-26.67-.3-26.67l-28.07.13ZM1571.22 436.85c.03.9-2.76 27.36-2.76 35.51 0 7.48 5.98 21.11 14.15 22.94 8.17 1.84 30.41 10.93 30.41 10.93l1.51 54.73-145.78 12.78-2.62-63.77s31.66-12.07 33.8-20.23c2.14-8.18-1.66-43.63-1.66-43.63l72.95-9.25Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1513.12 325.24c-10.07 1.91-5.17 8.76-15.71 13.53-10.55 4.77-27.05 6.52-28.76 16.99-1.72 10.48 5.03 9.79 1.76 16.5-3.28 6.72-5.38 18.37-1.82 26.54 1.65 3.77 5.46 13.4 7.9 17.84 2.83 5.17 3.1 18.67 3.1 18.67l96.42-19.39s-3.67-9.81-1.45-13.52 2.48-5.14 4.04-13.97c1.56-8.83-8.31-11.53-8.48-19.78-.15-8.25-4.24-23.2-13.18-31.23-8.94-8.03-23.99-.52-27.54-5.83-3.56-5.29-10.49-7.48-16.29-6.36h.01Z"
        style={{
          fill: '#d0b46a',
        }}
      />
      <path
        d="M1499.22 380.97c-4.86 4.73 3 12.21-5.52 17.26-8.53 5.05-14.14 7.56-11.86 11.4 2.29 3.84-.69 5.84-.69 5.84s-6.04-4.98-11.35-.17c-5.32 4.82 3.49 21.67 6.66 28.1s5.08 6 8.18 6.32c3.1.32 5.27-2.48 5.27-2.48s2.21 13.02 7.87 17.88 21.75 16.81 27.89 19.81c6.14 2.98 20.65 1.13 26.2-4.62 5.56-5.74 15.57-21.6 17.75-25.65 2.18-4.05 2.34-18.29 2.34-18.29s5.42 1.65 8.08-.14c2.65-1.77 4.52-13.88 6.1-18.4 1.58-4.52.13-15.84-4.7-17.02-4.83-1.18-9.56 6.8-9.56 6.8s-3.91.32-2.72-5.77 5.17-11.63-5.89-12.19c-11.04-.56-22.71 13.7-32.81 10.67-10.1-3.03-8.39-14.94-15.18-20.18s-13.53-1.69-16.08.8Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1532.69 402.43s16.53-3.22 19.29-2.49c2.76.73 8.45 2.96 8.45 2.96l-.86 2.55s-9.8-2.03-14.28-.44-10.59 3.11-10.59 3.11l-2.01-5.69ZM1520.48 403.27s-15.04.49-17.09 1.73-6.03 4.45-6.03 4.45l1.63 2.14s7.5-3.89 11.84-3.37 10.02.65 10.02.65l-.35-5.62h-.03Z"
        style={{
          fill: '#9e6c30',
        }}
      />
      <path
        d="M1521.06 461.41c.31 1.49 2.28.44 3.48 2.06s5.55 3.97 11.5 3.76c1.97.96 5.36-.77 7.01-1.53s3.82-3.8 5.05-4.21c1.24-.41 2.97-.93 2.86-2.48s-7.93-2.76-10.57-2.62-3.77 2.11-4.6 2.03-2.1-1.51-4.25-1.48c-2.15.04-5.76 2.04-6.67 2.25-.9.21-4.17.48-3.8 2.21Z"
        style={{
          fill: '#f09b7d',
        }}
      />
      <path
        style={{
          fill: '#4e3950',
        }}
        d="m1498.57 421.34 6.51-.13-.14-4.42-6.93 1.9.56 2.65z"
      />
      <path
        d="M1505.96 415.45c-2.7 1.35-3.7 4.11-2.28 6.72 1.42 2.6 3.67 2.82 6.18 1.76 2.96-1.24 3.73-3.79 2.53-6.62-.84-1.99-3.66-3.25-6.45-1.87h.01ZM1557.12 413.7l-6.44 2.83-1.08-4.01 6.57-1.2.95 2.38z"
        style={{
          fill: '#4e3950',
        }}
      />
      <path
        d="M1547.15 411.1c3.03 0 5.14 2.06 5.03 5.01-.13 2.96-2.06 4.15-4.76 4.32-3.2.2-5.03-1.75-5.21-4.8-.13-2.15 1.83-4.53 4.94-4.53Z"
        style={{
          fill: '#4e3950',
        }}
      />
      <path
        d="M1442.65 635.89s-7.48 59.64-10.31 70.47c-2.82 10.84-5.73 47.18-21.01 50.33-15.28 3.15-23.03-31.76-22.06-42.62.97-10.87 10.98-86.32 10.98-86.32l42.39 8.14Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1415.11 679.26c12.36-1.04 20.12 22.13 19.12 50.15-.99 28.02-6.55 85-6.55 85l-24.48 14.07s-13.28-92.62-12.9-105.34c.38-12.73 12.16-42.82 24.81-43.87Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
      <path
        d="M1627.32 776.35s6.07 125.27 12.01 167.66c5.94 42.39 6.72 191.13 5.46 221.74-1.25 30.61-1.08 87.17-1.08 87.17s-13.77 17.11-36.59 13.31c-22.84-3.8-37.07-14.84-37.07-14.84s-6.53-105.72-5.53-153.58-9.71-130.91-20.02-160.07-9.91-83.66-19.44-108c-9.55-24.34-18.73-69.81-18.73-69.81l120.99 16.43h.01Z"
        style={{
          fill: '#44679e',
        }}
      />
      <path
        d="M1537.15 782.93s-.58 146.02.66 194.2c1.25 48.18-9.94 106.06-2.59 156.25s-5.14 123.27-5.14 123.27-8.8 8.21-26.41 6.91c-17.6-1.3-44.9-7.24-44.9-7.24s-9.05-56.12-7.21-109.6c1.84-53.47 1.75-97.12 2.98-128.25 1.25-31.14-15.9-95.37-17.46-119.32-1.58-23.95 1.55-101.79 1.55-101.79l98.5-14.42h.01Z"
        style={{
          fill: '#44679e',
        }}
      />
      <path
        d="M1523.83 811.79s-.03.51-.06 1.39"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1523.58 818.28c-.06 1.52-.11 3.24-.17 5.1"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeDasharray: '0 0 0 0 0 0 1.81 3.62',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1523.32 825.94c-.27 9.17-.48 20.42-.14 26.16.44 7.1 7.22 9.83 11.7 10.86"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeDasharray: '0 0 0 0 0 0 0 0 0 0 1.81 3.62',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1537.4 863.4c.86.11 1.39.14 1.39.14"
        style={{
          fill: 'none',
          stroke: '#ffd500',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '1.59px',
        }}
      />
      <path
        d="M1580.9 493.41s-13.53 22.41-42.37 21.72-46.79-18.54-46.79-18.54-60.64 28.99-63.4 30.68c-2.76 1.69-4.73 46.52 4.17 60.3 8.9 13.77 13.43 62.87 10.88 89.79-2.55 26.92-14.52 161.18-14.52 161.18s47.34 6.27 76.48 6.59c50.25.58 93.95-22.48 103.67-21.91 9.71.58 30.64-.8 30.64-.8s-.83-32.81-4.67-51.87c-3.82-18.95-5.89-47.36-6.58-78.55-.69-31.06-8.94-79.9-3.8-105.03s30.61-64.22 20.91-69.92c-9.71-5.72-64.65-23.65-64.65-23.65h.03Z"
        style={{
          fill: '#f3f1e3',
        }}
      />
      <path
        d="M1676.75 628.01s-25.05 3.49-41.24 6.29c-16.21 2.8-41.83-3.11-41.83-3.11s34.16-127.84 52.85-112.75c18.7 15.08 17.28 57.22 21.92 69.69 4.66 12.47 8.29 39.87 8.29 39.87ZM1430.1 526.9c13.73-2.58 28.92 113.76 28.92 113.76s-15.99-4-33.69-5.14c-17.7-1.14-40.11-6.98-40.11-6.98s12.4-35.82 15.83-50.66c3.42-14.85 14.42-48.22 29.06-50.97Z"
        style={{
          fill: '#f3f1e3',
        }}
      />
      <path
        d="M1428.02 790.19s1.01 26.39 4.77 37.65c4.27 12.83 11.39 26.99 11.98 30.12 1.11 5.87.68 19.63 1.14 25.3.46 5.66.94 16.3.94 16.3s-7.17.07-9.32-5.52-.39-20.19-4.48-20.09c-5.08.11-5.81 14.23-4.51 20.11 1.32 5.87 14.56 11.6 16.63 15.3 2.07 3.7-1.76 12.6-1.76 12.6s-21.8-10.67-26.98-13.29-13.81-25.54-16.11-29.47c-1.55-2.66 3.45-34.11 2.31-44.62s-5.55-46.74-5.55-46.74l30.9 2.38v-.03Z"
        style={{
          fill: '#f8c4b7',
        }}
      />
    </svg>
  )
}

export default GangEnd
